import { NavigationActions } from "@/components/navigation/ducks/slice"
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"

/** @typedef {Object} AutoenrichState
 * @property {Array<AutoenrichRun>} runs
 * @property {boolean} fetchingRuns
 */

/** @type {AutoenrichState} */
const initialState = {
  runs: [],
  fetchingRuns: false,
}

/** @typedef {Object} fetchAutoenrichHistoryThunkParams
 * @property {(data: any) => void} onSuccess
 * @property {(err: unknown) => void} onError
 *
 */

const fetchAutoenrichHistory = createAsyncThunk(
  "autoenrich/fetchHistory",
  /** @param {fetchAutoenrichHistoryThunkParams} params */
  async ({ onSuccess, onError }) => {
    // const { history } = await apiFetchAutoenrichHistory(onSuccess, onError)
    const history = []

    return history
  },
)

/** @typedef {import("@/components/autoenrich/api").TriggerRunRequest} TriggerRunRequest */
/** @typedef {import("@/components/autoenrich/api").TriggerRunResponse} TriggerRunResponse */

/** @typedef {Object} TriggerRunThunkParams
 * @property {TriggerRunRequest} data
 * @property {(data: TriggerRunResponse) => void} onSuccess
 * @property {(err: unknown) => void} onError
 *
 */

const triggerNewRun = createAsyncThunk(
  "autoenrich/triggerRun",
  /** @param {TriggerRunThunkParams} params */
  async ({ data, onError, onSuccess }, { dispatch }) => {
    // const resp = await apiTriggerNewRun(data, onSuccess, onError)
    //
    // if (resp.enqueued) {
    //   return resp.view
    // }

    dispatch(NavigationActions.setSnackbar("This customer has no autoenrich candidates"))
    return null
  },
)

const autoenrichSlice = createSlice({
  name: "autoenrich",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAutoenrichHistory.pending, (state) => {
        state.fetchingRuns = true
      })
      .addCase(fetchAutoenrichHistory.fulfilled, (state, action) => {
        state.runs = action.payload
        state.fetchingRuns = false
      })
      .addCase(fetchAutoenrichHistory.rejected, (state) => {
        state.fetchingRuns = false
      })
      .addCase(triggerNewRun.fulfilled, (state, action) => {
        if (action.payload) state.runs = [action.payload, ...state.runs]
      })
  },
})

export const AUTOENRICH_ACTIONS = {
  ...autoenrichSlice.actions,
  fetchAutoenrichHistory,
  triggerNewRun,
}

export default autoenrichSlice.reducer
